module.exports = __webpack_public_path__ + "static/europe_character_home.70e8501c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/subdomen/europe_character_home.svg
// module id = 905
// module chunks = 35783957827783